module.exports = __webpack_public_path__ + "media/images/app_buttons/button__googlePlay-d381a5a6db4c393b2db187db6bf2dd90.svg";